import React from 'react';
import { Grid } from '@mui/material';
import { CotizacionData, ItemCotizacionData, ItemOfertaData } from '../../types';
import { PricingFields } from './fields/PricingFields';
import { PaymentFields } from './fields/PaymentFields';
import { DeliveryFields } from './fields/DeliveryFields';
import { ObservacionesField } from './fields/ObservacionesField';

interface ItemFormFieldsProps {
  currentItem: ItemOfertaData;
  item: ItemCotizacionData;
  itemIndex: number;
  parentData: CotizacionData;
  localSelectedDate: string;
  setLocalSelectedDate: (date: string) => void;
  handleItemChange: (field: keyof ItemOfertaData, value: string | number) => void;
  shouldValidate?: boolean; // Si debe mostrar validaciones de campos requeridos
}

/**
 * Componente para los campos del formulario de item
 */
export const ItemFormFields: React.FC<ItemFormFieldsProps> = ({
  currentItem,
  item,
  itemIndex,
  parentData,
  localSelectedDate,
  setLocalSelectedDate,
  handleItemChange,
  shouldValidate = true,
}) => {
  return (
    <Grid container spacing={2}>
      <PricingFields
        currentItem={currentItem}
        itemIndex={itemIndex}
        handleItemChange={handleItemChange}
        shouldValidate={shouldValidate}
      />
      <PaymentFields
        currentItem={currentItem}
        itemIndex={itemIndex}
        handleItemChange={handleItemChange}
      />
      <DeliveryFields
        currentItem={currentItem}
        itemIndex={itemIndex}
        parentData={parentData}
        maxUnidadesSolicitadas={item.totalUnidadesSolicitadas}
        localSelectedDate={localSelectedDate}
        setLocalSelectedDate={setLocalSelectedDate}
        handleItemChange={handleItemChange}
        shouldValidate={shouldValidate}
      />
      <ObservacionesField
        currentItem={currentItem}
        handleItemChange={handleItemChange}
      />
    </Grid>
  );
};
